import React from 'react';
import LegalDocument from '../Common/LegalDocument';
import { useLocale } from '../../localization/LocaleContext';
import { getTermsPageContent } from '../../localization/legalPageContent';

export default function Terms(){
    const { locale, toLocalizedPath } = useLocale();
    const content = getTermsPageContent(locale, {
        privacyPolicyPath: toLocalizedPath('privacyPolicy'),
        cookiePolicyPath: toLocalizedPath('cookiePolicy')
    });

    return <LegalDocument {...content} />;
}